import './app/boot';



// WEBPACK FOOTER //
// ./src/index.js